import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { radius } from '@vuelto/tokens';
import { agenda, agendaFonts } from '../domain/agendaTheme';
import { ticketColors } from '../../shared/theme/ticketColors';

type Props = {
  total: number;
  active: number;
  inactive: number;
};

export function AgendaKpiStrip({ total, active, inactive }: Props) {
  return (
    <View style={styles.grid}>
      <View style={styles.row}>
        <KpiCell value={total} label="Agendas" />
        <KpiCell value={active} label="Activas" ok />
        <KpiCell value={inactive} label="Inactivas" isLast />
      </View>
    </View>
  );
}

function KpiCell({
  value,
  label,
  isLast = false,
  ok = false,
}: {
  value: number;
  label: string;
  isLast?: boolean;
  ok?: boolean;
}) {
  return (
    <View style={[styles.cell, !isLast && styles.cellBorder]}>
      <Text style={[styles.num, ok && styles.numOk]}>{value}</Text>
      <Text style={styles.lab}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  grid: {
    backgroundColor: agenda.surface,
    borderWidth: 1,
    borderColor: agenda.border,
    borderRadius: radius.md,
    overflow: 'hidden',
    marginHorizontal: 16,
    marginBottom: 12,
  },
  row: { flexDirection: 'row' },
  cell: {
    flex: 1,
    paddingVertical: 12,
    paddingHorizontal: 6,
    alignItems: 'center',
    gap: 4,
  },
  cellBorder: { borderRightWidth: 1, borderRightColor: agenda.border },
  num: {
    fontSize: 18,
    fontWeight: '700',
    color: agenda.ink,
    fontFamily: agendaFonts.mono,
    letterSpacing: -0.4,
  },
  numOk: { color: ticketColors.ok },
  lab: {
    fontSize: 10,
    fontWeight: '600',
    color: agenda.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    fontFamily: agendaFonts.sans,
  },
});
